import { ISubscriptionItem } from './../../../../../../store/models/register.model';
import { RegisterService } from './../../../../../../store/services/register.service';
import { Subscription } from 'rxjs';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

import { RegisterForm, RegisterFormPay } from '../../../../../../store/models/register.model';
import { Store } from '@ngrx/store';
import { PageState } from '../../../../../../store/models/page.model';
import { setBannerComponent } from '../../../../../../store/actions/page.action';
import { InputTooltipOptions } from 'app/store/models/popover.model';
import { ISelectItem } from 'app/store/models/select.model';
import { DiscountsService } from '../../../../../../store/services/discounts.service';
import { IPlanProduct } from '../../../../../../store/models/discount.model';
import { ButtonComponent } from '../../../../../ui/button/button.component';

@Component({
  selector: 'app-register-step-pay',
  templateUrl: './register-step-pay.component.html',
  styleUrls: ['./register-step-pay.component.scss'],
})
export class RegisterStepPayComponent implements OnInit, OnDestroy {
  @Input() paymentErrors: any = {};

  @Input() preFilledPayData: RegisterFormPay;

  @Output() Submit: EventEmitter<RegisterForm> =
    new EventEmitter<RegisterForm>();

  @ViewChild('buttonComponent') buttonComponent: ButtonComponent;

  registerForm: FormGroup;

  inputTooltipOptions: InputTooltipOptions = {
    text: 'Card Identification Number(CID)',
  };

  currentValidTeamCode: ISubscriptionItem;

  noTeamCodeCharge = '249';

  months: ISelectItem[] = [];

  currentMonth: number;

  years: ISelectItem[] = [];
  currentYear: number;

  products: IPlanProduct[] = [];

  selectedPlan: IPlanProduct;

  componentReady = false;

  private teamCodeSubscribed: Subscription;

  constructor(
    private store: Store<PageState>,
    private registerService: RegisterService,
    private readonly discountService: DiscountsService,
  ) {
    this.store.dispatch(setBannerComponent({ banner: 'Payment' }));
    this.discountService.getPlanProducts()
      .subscribe(data => {
        this.products = data.items;
        this.onPlanChange(6);
        this.componentReady = true;
      });
  }

  get plan_amount() {
    return this.registerForm.get('plan_amount');
  }

  get amount() {
    return this.registerForm.get('amount');
  }

  get discount() {
    return this.registerForm.get('discount');
  }

  get card_id() {
    return this.registerForm.get('card_id');
  }

  get expire_year() {
    return this.registerForm.get('expire_year');
  }

  get expire_month() {
    return this.registerForm.get('expire_month');
  }

  get card_number() {
    return this.registerForm.get('card_number');
  }

  get card_name() {
    return this.registerForm.get('card_name');
  }

  getPlanItems(): ISelectItem[] {
    return this.products.map(p => ({
      label: p.name,
      value: p.plan_id,
    }));
  }

  submitForm = () => {
    if (this.registerForm.valid) {
      this.Submit.emit(this.registerForm.getRawValue());
    } else {
      this.buttonComponent.release();
      this.registerForm.markAllAsTouched();
    }
  };

  getMonths() {
    return moment.months();
  }

  getYears() {
    const currentYear = moment().year();
    const result = [currentYear];
    for (let i = currentYear; i < currentYear + 16; i++) {
      result.push(i);
    }

    return result;
  }

  ngOnDestroy(): void {
    if (this.teamCodeSubscribed) {
      this.teamCodeSubscribed.unsubscribe();
    }
  }

  getPreFilledData(property) {
    if (!this.preFilledPayData) {
      return null;
    }

    return this.preFilledPayData.hasOwnProperty(property)
      ? this.preFilledPayData[property]
      : null;
  }

  ngOnInit() {
    window.scroll(0, 0);
    const months = this.getMonths();
    for (let i = 0; i < months.length; i++) {
      this.months.push({
        label: months[i],
        value: i + 1,
      });
    }
    this.currentMonth = moment().month() + 1;

    const years = this.getYears();
    for (const item of years) {
      this.years.push({
        label: item.toString(),
        value: item,
      });
    }
    this.currentYear = moment().year();
    this.registerForm = new FormGroup({
      card_name: new FormControl(this.getPreFilledData('card_name') || '', [
        Validators.required,
      ]),
      card_number: new FormControl(this.getPreFilledData('card_number') || '', [
        Validators.required,
      ]),
      expire_month: new FormControl(
        this.getPreFilledData('expire_month') || moment().month() + 1,
        [Validators.required],
      ),
      expire_year: new FormControl(
        this.getPreFilledData('expire_year') || moment().year(),
        [Validators.required],
      ),
      card_id: new FormControl(this.getPreFilledData('card_id') || '', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(4),
        Validators.pattern(/^[0-9]*$/),
      ]),
      discount: new FormControl(this.getPreFilledData('discount') || ''),
      amount: new FormControl('$' + this.noTeamCodeCharge),
      plan_amount: new FormControl(),
      email: new FormControl(localStorage.getItem('email')),
      plan_id: new FormControl(6, [Validators.required]),
    });

  }

  onPlanChange($event: any) {
    this.selectedPlan = this.products.find((p) => p.plan_id === $event);
  }
}
